module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img69.aa9af2ea.jpg";